<div class="dashboard-small-container h-full">
  <div class="dashboard-small-container-content h-full">
    <div class="flex flex-col w-full h-full">

      <div class="flex flex-row w-full items-center">
        <div class="dashboard-icon-border">
          <div class="dashboard-icon" [innerHTML]="iconSvg()"></div>
        </div>
        <div class="flex-1 ml-3 min-w-0" [title]="title()">
          <h3 class="special-font font-bold text-xl truncate">
            {{ title() }}
          </h3>
        </div>
      </div>

      <div class="dashboard-container h-full">
        <div class="dashboard-number" [class.cursor-pointer]="clickable()"
             (click)="onClick()">
          <div class="flex flex-wrap items-center justify-center">
            {{ mainValue() }}
            @if (chartData() && !isEmpty()) {
              <donut-chart
                [data]="chartData()"
                [entityName]="entityName()"/>
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
